// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-about-js": () => import("../src/pages/about.js" /* webpackChunkName: "component---src-pages-about-js" */),
  "component---src-pages-events-js": () => import("../src/pages/events.js" /* webpackChunkName: "component---src-pages-events-js" */),
  "component---src-pages-index-js": () => import("../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-new-stadium-js": () => import("../src/pages/new-stadium.js" /* webpackChunkName: "component---src-pages-new-stadium-js" */),
  "component---src-pages-teams-js": () => import("../src/pages/teams.js" /* webpackChunkName: "component---src-pages-teams-js" */)
}

